import styles from "./RichText.module.scss";

/**
 * Heading + paragraphs. Surface-aware (light | grey | dark) and supports a
 * two-column paragraph layout (`columns: 2`) used by the dark "Manufacturer"
 * section. `align: "center"` centers the heading (dark sections in Figma).
 * `body` may be a string or an array of paragraph strings.
 */
export default function RichText({
  heading,
  body,
  surface = "grey",
  columns = 1,
  align = "left",
}) {
  const paras = Array.isArray(body) ? body : body ? [body] : [];
  if (!heading && !paras.length) return null;

  return (
    <section className={`${styles.section} ${styles[surface]}`}>
      <div className={styles.content}>
        {heading && (
          <h2 className={`${styles.heading} ${align === "center" ? styles.center : ""}`}>
            {heading}
          </h2>
        )}
        <div className={columns === 2 ? styles.twoCol : ""}>
          {paras.map((p, i) => (
            <p className={styles.para} key={i}>
              {p}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
}
